import { createContext } from "react";

export interface LyricsModalContextType {
    lyricsModalOpen: boolean;
    setLyricsModalOpen: (open: boolean) => void;
    artist: string | undefined;
    track: string | undefined;
    lyrics: string | undefined;
    loading: boolean;
    errorOccurred: boolean;
    setArtist: (artist: string | undefined) => void;
    setTrack: (track: string | undefined) => void;
    setLyrics: (lyrics: string | undefined) => void;
    setLoading: (loading: boolean) => void;
    setErrorOccurred: (errorOccurred: boolean) => void;
}

const LyricsModalContext = createContext<LyricsModalContextType | undefined>(undefined);

export default LyricsModalContext;